import { create } from "zustand";
import { baseURL, baseURLWithoutAPI } from "../../../baseUrl";
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { notification } from "antd";

export const useUserActions = create((set, get) => ({
    profile: [],
    perssonel: [],
    user: [],
    loaderUser: false,
    admin: [],
    users: [],
    usersPagination: {},
    filtredUsers: [],
    cardNumbers: [],
    isHaveStateWithFilter: false,
    createdUserId: "",
    followersList: [],
    followingList: [],
    userWallet: [],
    walletBalance: {},
    walletByUserId: [],
    userInfo: null,
    paymentListForPanel: [],
    usersObj: {},
    userStatics: [],
    staticsLoader: false,
    userAdsNum: {},
    walletByUserPagination: {},
    actions: {
        editUserNew: async (
            id, lastUserId, firstName, lastName, businessExpertise, businessAccountName,
            adsMainCategoryCode, nationalCode, email, gender, mobileNumber, phoneNumber, emergencyNumber, birthDate,
            country, state, city, longitudes, latitudes, address, isBusinessUser, description, businessAcntDescription, perssonelPicUrl, businessPicUrl, profilePicUrl,
            businessLicensePicUrl, shPicUrl, otherDocumnetUrl, nationalCardPicUrl, positionCode, businessLicenseNumber, instagramId, telegramId,
            userTypeCode, userRegisterStatusCode, registerDate, isUpdated, isShowPhoneNumber, isChatEnable
        ) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseURL}/User/EditUser`, {
                "id": id,
                "lastUserId": lastUserId,
                "firstName": firstName,
                "lastName": lastName,
                "businessExpertise": businessExpertise,
                "businessAccountName": businessAccountName,
                "adsMainCategoryCode": adsMainCategoryCode,
                "nationalCode": nationalCode,
                "email": email,
                "gender": gender,
                "mobileNumber": mobileNumber,
                "phoneNumber": phoneNumber,
                "emergencyNumber": emergencyNumber,
                "birthDate": birthDate,
                "country": country,
                "state": state,
                "city": city,
                "longitudes": longitudes,
                "latitudes": latitudes,
                "address": address,
                "isBusinessUser": isBusinessUser,
                "description": description,
                "businessAcntDescription": businessAcntDescription,
                "perssonelPicUrl": perssonelPicUrl,
                "businessPicUrl": businessPicUrl,
                "profilePicUrl": profilePicUrl,
                "businessLicensePicUrl": businessLicensePicUrl,
                "shPicUrl": shPicUrl,
                "otherDocumnetUrl": otherDocumnetUrl,
                "nationalCardPicUrl": nationalCardPicUrl,
                "positionCode": positionCode,
                "businessLicenseNumber": businessLicenseNumber,
                "instagramId": instagramId,
                "telegramId": telegramId,
                "userTypeCode": userTypeCode,
                "userRegisterStatusCode": userRegisterStatusCode,
                "registerDate": registerDate,
                "isUpdated": isUpdated,
                "isShowPhoneNumber": isShowPhoneNumber,
                "isChatEnable": isChatEnable
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.status == 200) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'اطلاعات کاربر با موفقیت ویرایش شد',
                        })
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                'ویرایش اطلاعات کاربر با خطا مواجه شد',
                        })
                    }
                }).catch(() => {
                    set((state) => ({ showServerError: true }))
                })
        },



        addLogin: async (id, userCode, userName, password,
            canAccessCityState,
            canAccessUsers,
            canAccessCreateUser,
            canAccessUsersList,
            canAccessCreateAds,
            canAccessAdsList,
            canAccessIncompleteAdsList,
            canAccessWaitingAds,
            waitingAdsState,
            waitingAdsCity,
            incompleteAdsState,
            incompleteAdsCity,
            canAccessMesageCenter,
            canAccessMessages,
            canAccessMonitoring,
            canAccessTariffManagement,
            canAccessDiscountsAndScores,
            canAccessPrices,
            canAccessPrize,
            canAccessContentManagement,
            canAccessSlides,
            canAcceessRules,
            canAccessAlerts,
            canAccessAbout,
            canAccessRealEstateAgents,
            canAccessRealEstateAgencies,
            canAccessConstructors,
            canAccessSupport,
            // canAccessMessages,
            canAccessReports,
            canAccessAutomaticMessages,
            canAccessBulkMessages,
            canAccessMessagesOptions,
            canAccessBlog,
            canAccessAds,
            canAccessAdsValidity
        ) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseURL}/Login/AddLogin`, {
                "id": id,
                "userCode": userCode,
                "userName": userName,
                "password": password,
                "canAccessCityState": canAccessCityState,
                "canAccessUsers": canAccessUsers,
                "canAccessCreateUser": canAccessCreateUser,
                "canAccessUsersList": canAccessUsersList,
                "canAccessCreateAds": canAccessCreateAds,
                "canAccessAdsList": canAccessAdsList,
                "canAccessIncompleteAdsList": canAccessIncompleteAdsList,
                "canAccessWaitingAds": canAccessWaitingAds,
                "waitingAdsState": waitingAdsState,
                "waitingAdsCity": waitingAdsCity,
                "incompleteAdsState": incompleteAdsState,
                "incompleteAdsCity": incompleteAdsCity,
                "canAccessMesageCenter": canAccessMesageCenter,
                "canAccessMessages": canAccessMessages,
                "canAccessMonitoring": canAccessMonitoring,
                "canAccessTariffManagement": canAccessTariffManagement,
                "canAccessDiscountsAndScores": canAccessDiscountsAndScores,
                "canAccessPrices": canAccessPrices,
                "canAccessPrize": canAccessPrize,
                "canAccessContentManagement": canAccessContentManagement,
                "canAccessSlides": canAccessSlides,
                "canAcceessRules": canAcceessRules,
                "canAccessAlerts": canAccessAlerts,
                "canAccessAbout": canAccessAbout,
                "canAccessRealEstateAgents": canAccessRealEstateAgents,
                "canAccessRealEstateAgencies": canAccessRealEstateAgencies,
                "canAccessConstructors": canAccessConstructors,
                "canAccessSupport": canAccessSupport,
                // canAccessMessages,
                "canAccessReports": canAccessReports,
                "canAccessAutomaticMessages": canAccessAutomaticMessages,
                "canAccessBulkMessages": canAccessBulkMessages,
                "canAccessMessagesOptions": canAccessMessagesOptions,
                "canAccessBlog": canAccessBlog,
                "canAccessAds": canAccessAds,
                "canAccessAdsValidity": canAccessAdsValidity

            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.status == 200) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'نام کاربری و رمز عبور کاربر با موفقیت ایجاد شد',
                        })
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                'ایجاد نام کاربری و رمز عبور با خطا مواجه شد',
                        })
                    }
                }).catch(() => {
                    set((state) => ({ showServerError: true }))
                })
        },


        editUserForPanel: async (
            id, lastUserId, firstName, lastName, businessExpertise,
            businessAccountName, adsMainCategoryCode,
            nationalCode, email, gender,
            mobileNumber, phoneNumber, emergencyNumber,
            birthDate, country, state, city, longitudes, latitudes,
            address, isBusinessUser, description, perssonelPicUrl,
            businessLicensePicUrl, shPicUrl, otherDocumnetUrl, nationalCardPicUrl, positionCode,
            businessLicenseNumber, instagramId, telegramId, userTypeCode, userRegisterStatusCode,
            isUpdated, isShowPhoneNumber, isChatEnable
        ) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseURL}/User/EditUser`, {
                "id": id,
                "lastUserId": lastUserId,
                "firstName": firstName,
                "lastName": lastName,
                "businessExpertise": businessExpertise,
                "businessAccountName": businessAccountName,
                "adsMainCategoryCode": adsMainCategoryCode,
                "nationalCode": nationalCode,
                "email": email,
                "gender": gender,
                "mobileNumber": mobileNumber,
                "phoneNumber": phoneNumber,
                "emergencyNumber": emergencyNumber,
                "birthDate": birthDate,
                "country": country,
                "state": state,
                "city": city,
                "longitudes": longitudes,
                "latitudes": latitudes,
                "address": address,
                "isBusinessUser": isBusinessUser,
                "description": description,
                "perssonelPicUrl": perssonelPicUrl,
                // "profilePicUrl": profilePicUrl,
                "businessLicensePicUrl": businessLicensePicUrl,
                "shPicUrl": shPicUrl,
                "otherDocumnetUrl": otherDocumnetUrl,
                "nationalCardPicUrl": nationalCardPicUrl,
                "positionCode": positionCode,
                "businessLicenseNumber": businessLicenseNumber,
                "instagramId": instagramId,
                "telegramId": telegramId,
                "userTypeCode": userTypeCode,
                "userRegisterStatusCode": userRegisterStatusCode,
                "isUpdated": isUpdated,
                "isShowPhoneNumber": isShowPhoneNumber,
                "isChatEnable": isChatEnable
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.status == 200) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'اطلاعات کاربر با موفقیت تغییر کرد',
                        })
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                'تغییر اطلاعات کاربر با خطا مواجه شد',
                        })
                    }
                }).catch(() => {
                    set((state) => ({ showServerError: true }))
                })
        },


        changeRegisterStatusCode: async (id, registerStatusCode) => {
            set((state) => ({ loaderUser: true }))
            await axios.patch(`${baseURL}/User/EditBusinessUser`, {
                "id": id,
                "registerStatusCode": registerStatusCode
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    // set((state) => ({ paymentListForPanel: res.data }))
                    set((state) => ({ loaderUser: false }))
                    if (res.status == 200) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'وضعیت کاربر با موفقیت تغییر کرد',
                        })
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                'تغییر وضعیت کاربر با خطا مواجه شد',
                        })
                    }

                })
        },

        requestPaymentListForPanel: async (
            id, userName, phoneNumber, dateTime, paymentFor, number,
            status, amount, userId, amountFrom, amountTo,
            transactionDateFrom, transactionDateTo, transType, result, searchQuery, page) => {
            set((state) => ({ loaderUser: true }))
            await axios.post(`${baseURL}/Payment/RequestPaymentListForPanel`, {
                "id": id,
                "userName": userName,
                "phoneNumber": phoneNumber,
                "dateTime": dateTime,
                "for": null,
                "number": number,
                "status": status,
                "amount": amount,
                "userId": userId,
                "paymentFor": paymentFor,
                "amountFrom": amountFrom,
                "amountTo": amountTo,
                "transactionDateFrom": transactionDateFrom,
                "transactionDateTo": transactionDateTo,
                "transType": transType,
                "result": result,
                "searchQuery": searchQuery,
                "page": page
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    set((state) => ({ paymentListForPanel: res.data?.data }))
                    set((state) => ({ paymentListPagination: res.data?.pagination }))
                    set((state) => ({ loaderUser: false }))

                })
        },

        // requestPaymentListForPanel: async (
        //     id, userName, phoneNumber, dateTime, paymentFor, number,
        //     status, amount, userId, paymentFor, amountFrom, amountTo,
        //     transactionDateFrom, transactionDateTo, transType, result) => {
        //     set((state) => ({ loaderUser: true }))
        //     await axios.post(`${baseURL}/Payment/RequestPaymentListForPanel`, {
        //         "id": id,
        //         "userName": userName,
        //         "phoneNumber": phoneNumber,
        //         "dateTime": dateTime,
        //         "for": paymentFor,
        //         "number": number,
        //         "status": status,
        //         "amount": amount,
        //         "userId": userId,
        //         "paymentFor": [
        //             paymentFor
        //         ],
        //         "amountFrom": amountFrom,
        //         "amountTo": amountTo,
        //         "transactionDateFrom": transactionDateFrom,
        //         "transactionDateTo": transactionDateTo,
        //         "transType": transType,
        //         "result": result
        //     })
        //         .then((res) => {
        //             set((state) => ({ paymentListForPanel: res.data }))
        //             set((state) => ({ loaderUser: false }))

        //         })
        // },


        getWalletByUserId: async (userId, paymentFor, amountFrom, amountTo, transactionDateFrom, transactionDateTo, transType, status, result, page) => {
            set((state) => ({ loaderUser: true }))

            await axios.post(`${baseURL}/Wallet/GetWalletByUserId`, {
                "userId": Number(userId),
                "paymentFor": paymentFor ? [
                    paymentFor
                ] : [],
                "amountFrom": amountFrom ? amountFrom : null,
                "amountTo": amountTo ? amountTo : null,
                "transactionDateFrom": transactionDateFrom ? transactionDateFrom : null,
                "transactionDateTo": transactionDateTo ? transactionDateTo : null,
                "transType": transType ? transType : null,
                "status": status ? status : null,
                "result": result ? result : null,
                "page": page ? page : 1,
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    set((state) => ({ walletByUserId: res.data?.result }))
                    set((state) => ({
                        walletByUserPagination: res.data?.pagination
                    }))
                    set((state) => ({ loaderUser: false }))

                })
        },

        getWalletBalanceByUserId: async (userId) => {
            await axios.get(`${baseURL}/Wallet/GetWalletBalanceByUserId?userId=${userId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    set((state) => ({ walletBalance: res.data }))
                })
        },

        editWalletDetail: async (userId, adsMasterCode, amount, paymentFor, transType) => {
            set((state) => ({ loaderUser: true }))
            await axios.post(`${baseURL}/Wallet/EditWalletDetail`,
                {
                    "userId": userId,
                    "adsMasterCode": adsMasterCode,
                    "amount": amount,
                    "paymentFor": paymentFor,
                    "transType": transType
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            }
            )
                .then((res) => {
                    if (res) {
                        set((state) => ({ userWallet: res.data }))
                        set((state) => ({ walletByUserId: res.data.tblWltWalletDetails }))
                        set((state) => ({ loaderUser: false }))
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'با موفقیت اضافه شد',
                        })
                    }
                })
        },


        editAddUser: async (
            id, lastUserId, firstName, lastName, businessExpertise,
            businessAccountName, adsMainCategoryCode,
            nationalCode, email, gender,
            mobileNumber, phoneNumber, emergencyNumber,
            birthDate, country, state, city, longitudes, latitudes,
            address, isBusinessUser, description, perssonelPicUrl,
            businessLicensePicUrl, shPicUrl, otherDocumnetUrl, nationalCardPicUrl, positionCode,
            businessLicenseNumber, instagramId, telegramId, userTypeCode, userRegisterStatusCode,
            isUpdated, isShowPhoneNumber, isChatEnable
        ) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseURL}/User/EditUser`, {
                "id": id,
                "lastUserId": lastUserId,
                "firstName": firstName,
                "lastName": lastName,
                "businessExpertise": businessExpertise,
                "businessAccountName": businessAccountName,
                "adsMainCategoryCode": adsMainCategoryCode,
                "nationalCode": nationalCode,
                "email": email,
                "gender": gender,
                "mobileNumber": mobileNumber,
                "phoneNumber": phoneNumber,
                "emergencyNumber": emergencyNumber,
                "birthDate": birthDate,
                "country": country,
                "state": state,
                "city": city,
                "longitudes": longitudes,
                "latitudes": latitudes,
                "address": address,
                "isBusinessUser": isBusinessUser,
                "description": description,
                "perssonelPicUrl": perssonelPicUrl,
                // "profilePicUrl": profilePicUrl,
                "businessLicensePicUrl": businessLicensePicUrl,
                "shPicUrl": shPicUrl,
                "otherDocumnetUrl": otherDocumnetUrl,
                "nationalCardPicUrl": nationalCardPicUrl,
                "positionCode": positionCode,
                "businessLicenseNumber": businessLicenseNumber,
                "instagramId": instagramId,
                "telegramId": telegramId,
                "userTypeCode": userTypeCode,
                "userRegisterStatusCode": userRegisterStatusCode,
                "isUpdated": isUpdated,
                "isShowPhoneNumber": isShowPhoneNumber,
                "isChatEnable": isChatEnable
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.status == 200) {
                        localStorage.setItem("userId", res.data.id)
                        set((state) => ({ userInfo: res.data }))
                        set((state) => ({ haveLike: true }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ isSuccessEdit: true }))
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'کاربر با موفقیت ایجاد شد',
                        })
                    }
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },



        getUserFollowingList: async (userId, searchQuery) => {
            set((state) => ({ loaderUser: true }))
            await axios.post(`${baseURL}/User/GetUserFollowingList`,
                {
                    "userId": userId,
                    "searchQuery": searchQuery
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }
            )
                .then((res) => {
                    if (res.status === 200) {
                        set((state) => ({ followingList: res.data }))
                        set((state) => ({ loaderUser: false }))
                    }
                })
        },

        getUserFollowersList: async (userId, searchQuery) => {
            set((state) => ({ loaderUser: true }))
            await axios.post(`${baseURL}/User/GetUserFollowersList`,
                {
                    "userId": userId,
                    "searchQuery": searchQuery
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }
            )
                .then((res) => {
                    if (res.status === 200) {
                        set((state) => ({ followersList: res.data }))
                        set((state) => ({ loaderUser: false }))
                    }
                })
        },

        getPerssonelImg: async (userId, directoryName) => {
            await axios.get(`${baseURL}/User/GetUserFileByIdUserDir?UserId=${userId}&directoryName=perssonelPic`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    set((state) => ({ perssonel: res.data }))
                })
        },

        editUser: async (
            id,
            firstName,
            lastName,
            // businessExpertise,
            // businessAccountName,
            // businessType,
            // nationalCode,
            mobileNumber,
            country,
            state,
            city,
            // longitudes,
            // latitudes,
            address,
            userType,
            userRegisterStatus
            // profilePicUrl,
            // showMore
        ) => {
            await axios.patch(`${baseURL}/User/EditUser`,
                {
                    "id": id,
                    "firstName": firstName,
                    "lastName": lastName,
                    // "businessExpertise": businessExpertise ? businessExpertise : null,
                    // "businessAccountName": businessAccountName ? businessAccountName : null,
                    // "businessType": "",
                    // "nationalCode": "",
                    // "email": "",
                    "gender": null,
                    "mobileNumber": mobileNumber,
                    // "phoneNumber": "",
                    // "emergencyNumber": "",
                    // "birthDate": null,
                    "country": country,
                    // "countryName": "ایران",
                    "state": state,
                    // "stateName": "خراسان",
                    "city": city,
                    // "cityName": "مشهد",
                    // "longitudes": null,
                    // "latitudes": null,
                    "address": address,
                    // "businessUser": null,
                    // "perssonelPicUrl": "",
                    // "profilePicUrl": "6384895464507206354e6f6.jpg",
                    // "businessLicensePicUrl": "",
                    // "shPicUrl": "",
                    // "otherDocumnetUrl": "",
                    // "nationalCardPicUrl": "",
                    // "positionCode": null,
                    // "businessLicenseNumber": "",
                    // "instagramId": "",
                    // "telegramId": "",
                    "userType": userType,
                    "userRegisterStatus": userRegisterStatus,
                    "registerDate": "2024-04-16T13:18:46.653"
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }
            )
                .then((res) => {
                    if (res) {
                        localStorage.setItem("userId", res.data.id)
                        toast('عملیات افزودن موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },


        editBusinessUser: async (
            id,
            firstName,
            lastName,
            businessExpertise,
            businessAccountName,
            businessType,
            nationalCode,
            // email,
            gender,
            mobileNumber,
            // phoneNumber,
            // emergencyNumber,
            // birthDate,
            country,
            // countryName,
            state,
            // stateName,
            city,
            // cityName,
            // longitudes,
            // latitudes,
            address,
            // businessUser,
            // perssonelPicUrl,
            // profilePicUrl,
            userType,
            userRegisterStatus,
            registerDate
        ) => {
            await axios.patch(`${baseURL}/User/EditUser`,
                {
                    "id": id,
                    "firstName": firstName,
                    "lastName": lastName,
                    "businessExpertise": businessExpertise,
                    "businessAccountName": businessAccountName,
                    "businessType": businessType,
                    "nationalCode": nationalCode,
                    // "email": "",
                    "gender": gender,
                    "mobileNumber": mobileNumber,
                    // "phoneNumber": "",
                    // "emergencyNumber": "",
                    "birthDate": "2024-04-16",
                    "country": country,
                    // "countryName": "ایران",
                    "state": state,
                    // "stateName": "خراسان",
                    "city": city,
                    // "cityName": "مشهد",
                    // "longitudes": null,
                    // "latitudes": null,
                    "address": address,
                    // "businessUser": null,
                    // "perssonelPicUrl": "",
                    // "profilePicUrl": "6384895464507206354e6f6.jpg",
                    // "businessLicensePicUrl": "",
                    // "shPicUrl": "",
                    // "otherDocumnetUrl": "",
                    // "nationalCardPicUrl": "",
                    // "positionCode": null,
                    // "businessLicenseNumber": "",
                    // "instagramId": "",
                    // "telegramId": "",
                    "userType": userType,
                    "userRegisterStatus": userRegisterStatus,
                    "registerDate": registerDate

                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }
            )
                .then((res) => {
                    if (res) {
                        localStorage.setItem("userId", res.data.id)
                        toast('عملیات افزودن موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },

        editTeammateUser: async (
            id,
            firstName,
            lastName,
            businessExpertise,
            businessAccountName,
            businessType,
            nationalCode,
            email,
            gender,
            mobileNumber,
            phoneNumber,
            emergencyNumber,
            // birthDate,
            country,
            // countryName,
            state,
            // stateName,
            city,
            instagramId,
            telegramId,
            // cityName,
            // longitudes,
            // latitudes,
            address,
            // businessUser,
            // perssonelPicUrl,
            // profilePicUrl,
            userType,
            userRegisterStatus,
            registerDate
        ) => {
            await axios.patch(`${baseURL}/User/EditUser`,
                {
                    "id": id,
                    "firstName": firstName,
                    "lastName": lastName,
                    "businessExpertise": businessExpertise,
                    "businessAccountName": businessAccountName,
                    "businessType": businessType,
                    "nationalCode": nationalCode,
                    "email": email,
                    "gender": gender,
                    "mobileNumber": mobileNumber,
                    "phoneNumber": phoneNumber,
                    "emergencyNumber": emergencyNumber,
                    "birthDate": "2024-04-16",
                    "country": country,
                    // "countryName": "ایران",
                    "state": state,
                    // "stateName": "خراسان",
                    "city": city,
                    // "cityName": "مشهد",
                    // "longitudes": null,
                    // "latitudes": null,
                    "address": address,
                    // "businessUser": null,
                    // "perssonelPicUrl": "",
                    // "profilePicUrl": "6384895464507206354e6f6.jpg",
                    // "businessLicensePicUrl": "",
                    // "shPicUrl": "",
                    // "otherDocumnetUrl": "",
                    // "nationalCardPicUrl": "",
                    // "positionCode": null,
                    // "businessLicenseNumber": "",
                    "instagramId": instagramId,
                    "telegramId": telegramId,
                    "userType": userType,
                    "userRegisterStatus": userRegisterStatus,
                    "registerDate": registerDate

                }
            )
                .then((res) => {
                    if (res) {
                        localStorage.setItem("userId", res.data.id)
                        toast('عملیات افزودن موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },


        getProfileImg: async (userId, directoryName) => {
            await axios.get(`${baseURL}/User/GetUserFileByIdUserDir?UserId=${userId}&directoryName=ProfilePic`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    set((state) => ({ profile: res.data }))
                })
        },

        clearUserInfo: async () => {
            set((state) => ({ user: [] }))
        },
        getUserById: async (userId) => {
            set((state) => ({ loaderUser: true }))
            await axios.get(`${baseURL}/User/GetAllUser?Id=${userId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (localStorage.getItem("pelakUserId") == userId) {
                        set((state) => ({ admin: res.data.result[0] }))
                    } else {
                        set((state) => ({ user: res.data.result[0] }))
                        set((state) => ({ usersObj: { ...state.usersObj, [userId]: res.data.result[0] } }))

                    }
                    set((state) => ({ loaderUser: false }))
                })
        },

        clearUserInfo: async () => {
            set((state) => ({ user: [] }))
        },

        getAllUsers: async (page, isFetch) => {
            
            await axios.get(`${baseURL}/User/GetAllUser?page=${page}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    // set((state) => ({ users: res.data }))
                    if (isFetch) {
                        set((state) => ({ users: res.data.result }))
                        set((state) => ({ usersPagination: res.data.pagination }))
                    } else {
                        if (res.data.length) {
                            set((state) => ({ users: [...state.users, ...res.data] }));
                        } else {
                            set((state) => ({ hasMore: false }))
                        }
                    }
                })
        },

        filterUsers: async (UserRegisterStatus, Country, State, City, UserType, lastLoginFrom, lastLoginTo, name, RegisterDateFrom, RegisterDateTo, LastId) => {
            set((state) => ({ loaderUser: true }))
            await axios.get(`${baseURL}/User/GetAllUser?Country=${Country ? Country : ""}&State=${State ? State : ""}&City=${City ? City : ""}&UserRegisterStatusCode=${UserRegisterStatus ? UserRegisterStatus : ""}&UserTypeCode=${UserType ? UserType : ""}&LastLoginFrom=${lastLoginFrom ? lastLoginFrom : ""}&LastLoginTo=${lastLoginTo ? lastLoginTo : ""}&Name=${name ? name : ""} 
                &RegisterDateFrom=${RegisterDateFrom ? RegisterDateFrom : ""}&RegisterDateTo=${RegisterDateTo ? RegisterDateTo : ""}&LastId=${LastId ? LastId : 0}
                `, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                        set((state) => ({ users: res.data.result }))
                        set((state) => ({ usersPagination: res.data.pagination }))
                    set((state) => ({ loaderUser: false }))

                    if (!res.data.length) {
                        set((state) => ({ isHaveStateWithFilter: true }))
                    }

                })
        },
        // searchUsers: async (
        //     Id,
        //     Country,
        //     State,
        //     City,
        //     UserRegisterStatusCode,
        //     UserTypeCode,
        //     RegisterDateFrom,
        //     RegisterDateTo,
        //     LastLoginFrom,
        //     LastLoginTo,
        //     followersCount,
        //     followingCount,
        //     AdsMasterCount,
        //     MobileNumber,
        //     Name,
        //     LastId

        // ) => {
        //     set((state) => ({ loaderUser: true }))
        //     await axios.get(`${baseURL}/User/GetAllUser?Id=${Id ? Id : 0}
        //         &Country=${Country ? Country : ""}
        //         &State=${State ? State : ""}
        //         &City=${City ? City : ""}
        //         &UserRegisterStatusCode=${UserRegisterStatusCode ? UserRegisterStatusCode : ''}
        //         &UserTypeCode=${UserTypeCode ? UserTypeCode : ''}
        //         &RegisterDateFrom=${RegisterDateFrom ? RegisterDateFrom : ''}
        //         &RegisterDateTo=${RegisterDateTo ? RegisterDateTo : ''}
        //         &LastLoginFrom=${LastLoginFrom ? LastLoginFrom : ''}
        //         &UserTypeCode=${UserTypeCode ? UserTypeCode : ''}
        //         &LastLoginFrom=${LastLoginFrom ? LastLoginFrom : ""}
        //         &LastLoginTo=${LastLoginTo ? LastLoginTo : ""}
        //         &followersCount=${followersCount ? followersCount : ''}
        //         &followingCount=${followingCount ? followingCount : ''}
        //         &AdsMasterCount=${AdsMasterCount ? AdsMasterCount : ''}
        //         &MobileNumber=${MobileNumber ? MobileNumber : ''}
        //         &Name=${Name ? Name : ""}
        //         &LastId=${LastId ? LastId : 0}
        //         `, {
        //         headers: {
        //             "accept": "text/plain",
        //             "Content-Type": "application/json",
        //             Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
        //         }
        //     })
        //         .then((res) => {
        //             set((state) => ({ users: res.data }))
        //             set((state) => ({ loaderUser: false }))

        //             if (!res.data.length) {
        //                 set((state) => ({ isHaveStateWithFilter: true }))
        //             }

        //         })
        // },
        searchUsers: async (
            Id,
            Country,
            State,
            City,
            UserRegisterStatusCode,
            UserTypeCode,
            RegisterDateFrom,
            RegisterDateTo,
            LastLoginFrom,
            LastLoginTo,
            followersCount,
            followingCount,
            AdsMasterCount,
            MobileNumber,
            Name,
            LastId
        ) => {
            set((state) => ({ loaderUser: true }));

            const params = new URLSearchParams();

            if (Id) params.append('Id', Id);
            else params.append('Id', 0);

            if (Country) params.append('Country', Country);
            if (State) params.append('State', State);
            if (City) params.append('City', City);
            if (UserRegisterStatusCode) params.append('UserRegisterStatusCode', UserRegisterStatusCode);
            if (UserTypeCode) params.append('UserTypeCode', UserTypeCode);
            if (RegisterDateFrom) params.append('RegisterDateFrom', RegisterDateFrom);
            if (RegisterDateTo) params.append('RegisterDateTo', RegisterDateTo);
            if (LastLoginFrom) params.append('LastLoginFrom', LastLoginFrom);
            if (LastLoginTo) params.append('LastLoginTo', LastLoginTo);
            if (followersCount) params.append('followersCount', followersCount);
            if (followingCount) params.append('followingCount', followingCount);
            if (AdsMasterCount) params.append('AdsMasterCount', AdsMasterCount);
            if (MobileNumber) params.append('MobileNumber', MobileNumber);
            if (Name) params.append('Name', Name);
            if (LastId) params.append('LastId', LastId);
            else params.append('LastId', 0);

            await axios
                .get(`${baseURL}/User/GetAllUser?${params.toString()}`, {
                    headers: {
                        accept: 'text/plain',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('pelakToken')}`,
                    },
                })
                .then((res) => {
                        set((state) => ({ users: res.data.result }))
                        set((state) => ({ usersPagination: res.data.pagination }))
                    set((state) => ({ loaderUser: false }));

                    if (!res.data.length) {
                        set((state) => ({ isHaveStateWithFilter: true }));
                    }
                });
        }
        ,
        createUser: async (
            firstName,
            lastName,
            businessExpertise,
            businessAccountName,
            businessType,
            nationalCode,
            mobileNumber,
            country,
            state,
            city,
            longitudes,
            latitudes,
            address,
            profilePicUrl,
            showMore
        ) => {
            await axios.patch(`${baseURL}/User/EditUser`,
                {
                    "id": 0,
                    "firstName": firstName,
                    "lastName": lastName,
                    "businessExpertise": businessExpertise,
                    "businessAccountName": businessAccountName,
                    "businessType": businessType,
                    "nationalCode": nationalCode,
                    "gender": 0,
                    "mobileNumber": mobileNumber,
                    "country": country,
                    "state": state,
                    "city": city,
                    "longitudes": longitudes,
                    "latitudes": latitudes,
                    "address": address,
                    "businessUser": showMore,
                    "profilePicUrl": profilePicUrl,
                    "positionCode": 0,
                    "userType": showMore ? 2 : 1,
                    "userRegisterStatus": 2,
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }
            )
                .then((res) => {
                    set((state) => ({ createdUserId: res.data.id }))
                    if (res.status === 200) {
                        localStorage.setItem("userId", res.data.id)
                        toast('عملیات افزودن موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },

        createTeannateUser: async (
            firstName,
            lastName,
            nationalCode,
            gender,
            mobileNumber,
            phoneNumber,
            emergencyNumber,
            birthDate,
            country,
            state,
            city,
            address,
            email,
            instagramId,
            telegramId,
            registerDate,
        ) => {
            await axios.patch(`${baseURL}/User/EditUser`,
                {
                    // "id": 0,
                    "firstName": firstName,
                    "lastName": lastName,
                    "businessExpertise": "",
                    "businessAccountName": "",
                    "businessType": "",
                    "nationalCode": String(nationalCode),
                    "gender": gender,
                    "mobileNumber": mobileNumber,
                    "phoneNumber": phoneNumber,
                    "emergencyNumber": emergencyNumber,
                    "birthDate": birthDate,
                    "country": country,
                    "state": state,
                    "city": city,
                    "longitudes": 0,
                    "latitudes": 0,
                    "address": address,
                    "businessUser": false,
                    "perssonelPicUrl": "",
                    "profilePicUrl": "",
                    "businessLicensePicUrl": "",
                    "shPicUrl": "",
                    "otherDocumnetUrl": "",
                    "nationalCardPicUrl": "",
                    "positionCode": 0,
                    "businessLicenseNumber": "",
                    "email": email,
                    "instagramId": instagramId,
                    "telegramId": telegramId,
                    "userType": 3,
                    "userRegisterStatus": 2,
                    "registerDate": registerDate
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        set((state) => ({ createdUserId: res.data.id }))
                        localStorage.setItem("userId", res.data.id)
                        toast('عملیات افزودن کاربر موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن کاربر موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },

        addCardNumbers: async (cardNumber, userCode) => {
            await axios.post(`${baseURL}/User/BulkInsertCardBankAccountInfo`,
                {
                    "bulkUserCardBankAccountInfo": cardNumber
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }
            )
                .then((res) => {
                    if (res.status === 200) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'شماره کارت کاربر با موفقیت افزوده شد',
                        })
                    }
                })
        },

        editCardNumbers: async (cardId, cardNumber, userCode) => {
            await axios.post(`${baseURL}/User/EditCardBankAccountInfo`,
                {
                    "id": cardId,
                    "cardNumber": cardNumber,
                    "userCode": userCode
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات افزودن شماره کارت موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات افزودن شماره کارت موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },

        getCardNumbers: async (userId) => {
            await axios.get(`${baseURL}/User/GetCardBankAccountInfoByUserId?id=${userId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    set((state) => ({ cardNumbers: res.data }))
                })
        },

        removeCardNumberByCardId: async (cardId) => {
            await axios.delete(`${baseURL}/User/DeleteCardBankAccountInfoById?id=${cardId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        toast('عملیات حذف شماره کارت موفقیت آمیز بود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    } else {
                        toast('عملیات حذف شماره کارت موفقیت آمیز نبود', {
                            position: "bottom-left",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });
                    }
                })
        },


        saveUserPersonnelImage: async (userId, file) => {
            await axios.post(`${baseURL}/User/SaveUserPersonnelImage?UserId=${userId}`, {
                "userId": userId,
                "file": file
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-rapidapi-host": "file-upload8.p.rapidapi.com",
                    "x-rapidapi-key": "your-rapidapi-key-here",
                },
            })
                .then((res) => {
                    notification.open({
                        icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg >,
                        message: 'عملیات موفق',
                        description:
                            'عکس پرسنلی با موفقیت افزوده شد',
                    })
                })
        },

        saveUserProfilelImage: async (userId, file) => {
            await axios.post(`${baseURL}/User/SaveUserProfileImage?UserId=${userId}`, {
                "userId": userId,
                "file": file
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-rapidapi-host": "file-upload8.p.rapidapi.com",
                    "x-rapidapi-key": "your-rapidapi-key-here",
                },
            })
                .then((res) => {
                    if (res.status === 200 || res.status === 204) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'پروفایل کاربر با اضافه شد',
                        })
                    }
                })
        },

        saveUsernationalImage: async (userId, file) => {
            await axios.post(`${baseURL}/User/SaveUserNationalCardImage?UserId=${userId}`, {
                "userId": userId,
                "file": file
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-rapidapi-host": "file-upload8.p.rapidapi.com",
                    "x-rapidapi-key": "your-rapidapi-key-here",
                },
            })
                .then((res) => {
                    if (res.status === 200 || res.status === 204) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'عکس کارت ملی با موفقیت افزوده شد',
                        })
                    }
                })
        },
        getUserAdsNum: async (userId, startDate, endDate) => {

            set((state) => ({ adsNumLoader: true }))
            await axios.post(`${baseURL}/User/UserStatisticsByUserId`, {
                "userId": userId,
                "startDate": startDate,
                "endDate": endDate
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {


                    if (res.status === 200 || res.status === 204) {
                        set((state) => ({ userAdsNum: res.data }))


                        set((state) => ({ adsNumLoader: false }))
                    }
                })
        },
        saveUserBirthCertificationImage: async (userId, file) => {
            await axios.post(`${baseURL}/User/SaveUserBirthCertificationImage?UserId=${userId}`, {
                "userId": userId,
                "file": file
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-rapidapi-host": "file-upload8.p.rapidapi.com",
                    "x-rapidapi-key": "your-rapidapi-key-here",
                },
            })
                .then((res) => {
                    if (res.status === 200 || res.status === 204) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                ' عکس شناسامه کاربر با موفقیت افزوده شد',
                        });
                    }
                })
        },
        getUserStatics: async (userId, startDate, endDate) => {

            set((state) => ({ staticsLoader: true }))
            await axios.post(`${baseURL}/User/UserStatistics`, {
                "userId": userId,
                "startDate": startDate,
                "endDate": endDate
            }, {
                headers: {

                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {


                    if (res.status === 200 || res.status === 204) {
                        set((state) => ({ userStatics: res.data }))
                        // notification.open({
                        //     icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        //         <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        //     </svg >,
                        //     message: 'عملیات موفق',
                        //     description:
                        //         ' عکس شناسامه کاربر با موفقیت افزوده شد',
                        // });

                        set((state) => ({ staticsLoader: false }))
                    }
                })
        },

        setUserStatics: (data) => set((state) => ({ userStatics: data })),

    }
}))

// export const todosGet = useGetTodos.setState